import React from 'react'

const About = () => {
  return (
    <div>Since 2015, Gameportng has been well-known as a trusted and efficient distributor of video gaming of all brands(Sony playstation, Xbox, Nintendo Switch, Steam Deck, Legion Go, et.c).  We fully understand the challenges of bringing entertainment and relaxation from the concept of video gaming, so we are dedicated to seamless process of giving standard, and we ensure the quality of every single product we sell to be of high quality and getting a feedback of good  customer's satisfaction.</div>
  )
}

export default About